var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canShow
    ? _c("div", { staticClass: "portlet light bordered" }, [
        _c("div", { staticClass: "portlet-title" }, [
          _c("div", { staticClass: "caption" }, [
            _c("i", { staticClass: "icon-equalizer font-red-sunglo" }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "caption-subject font-red-sunglo bold uppercase" },
              [_vm._v(_vm._s(_vm.trans("note.note")))]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body form" }, [
          _c(
            "div",
            { staticClass: "timeline" },
            [
              _c("div", { staticClass: "timeline-item" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "timeline-body" }, [
                  _c("div", { staticClass: "timeline-body-arrow" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "timeline-body-head" }, [
                    _c("div", { staticClass: "timeline-body-head-caption" }, [
                      _c(
                        "a",
                        {
                          staticClass: "timeline-body-title font-blue-madison",
                          attrs: { href: "#!" }
                        },
                        [_vm._v(_vm._s(_vm.trans("note.add")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "timeline-body-time font-grey-cascade" },
                        [_vm._v(_vm._s(_vm.date))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "timeline-body-content" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.note,
                          expression: "note"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        rows: "3",
                        placeholder: _vm.trans("note.default_note")
                      },
                      domProps: { value: _vm.note },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.note = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-12 text-right" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: { click: _vm.addNote }
                        },
                        [_vm._v(_vm._s(_vm.trans("note.save")))]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.list, function(item, index) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "timeline-item list-complete-animation",
                      attrs: { "data-note-id": item.id }
                    },
                    [
                      _c("div", { staticClass: "timeline-badge" }, [
                        _c(
                          "div",
                          {
                            class: {
                              "timeline-icon bg-yellow-gold": item.editMode,
                              "timeline-icon": !item.editMode
                            }
                          },
                          [_c("i", { staticClass: "icon-bubbles" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "timeline-body" }, [
                        _c("div", { staticClass: "timeline-body-arrow" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "timeline-body-head" }, [
                          _c(
                            "div",
                            { staticClass: "timeline-body-head-caption" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "timeline-body-title font-blue-madison",
                                  attrs: { href: "#!" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.userName ? item.userName : "")
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "timeline-body-time font-grey-cascade"
                                },
                                [_vm._v(_vm._s(_vm.formatDate(item.createdAt)))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showActions(item.userId)
                            ? _c(
                                "div",
                                { staticClass: "timeline-body-head-actions" },
                                [
                                  _c("div", { staticClass: "btn-group" }, [
                                    _vm.canEdit
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-circle btn-sm",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.editMode(index)
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: {
                                                "fa fa-check": item.editMode,
                                                "fa fa-pencil": !item.editMode
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-circle btn-sm",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.remove(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          class: {
                                            "fa fa-times": item.editMode,
                                            "fa fa-trash": !item.editMode
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "timeline-body-content" }, [
                          item.editMode
                            ? _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: item.note,
                                    expression: "item.note"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { rows: "3" },
                                domProps: { value: item.note },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(item, "note", $event.target.value)
                                  }
                                }
                              })
                            : _c("span", { staticClass: "font-grey-cascade" }, [
                                _vm._v(" " + _vm._s(item.note))
                              ])
                        ])
                      ])
                    ]
                  )
                ]
              })
            ],
            2
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "timeline-badge" }, [
      _c("div", { staticClass: "timeline-icon" }, [
        _c("i", { staticClass: "icon-note" })
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24f88c05", { render: render, staticRenderFns: staticRenderFns })
  }
}